/* Istanbul Furniture – behaviour layer that replaces the Lovable React runtime. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* money: $1,750 (no trailing zeros), $1,750.50 */
  function money(cents) {
    var v = cents / 100, whole = cents % 100 === 0;
    return '$' + v.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  }
  window.LVmoney = money;

  /* ---------- header ---------- */
  var header = $('[data-lv-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('shadow-sm', window.scrollY > 20); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }
  var trig = $('[data-lv-mega-trigger]'), mega = $('[data-lv-mega]'), megaTimer;
  if (trig && mega) {
    var chev = trig.querySelector('svg');
    var OFF = ['text-charcoal', 'border-transparent', 'hover:text-primary'], ON = ['text-primary', 'border-primary'];
    var open = function () {
      clearTimeout(megaTimer); mega.hidden = false;
      OFF.forEach(function (c) { trig.classList.remove(c); }); ON.forEach(function (c) { trig.classList.add(c); });
      chev && chev.classList.add('rotate-180');
    };
    var close = function () {
      clearTimeout(megaTimer);
      megaTimer = setTimeout(function () {
        mega.hidden = true;
        ON.forEach(function (c) { trig.classList.remove(c); }); OFF.forEach(function (c) { trig.classList.add(c); });
        chev && chev.classList.remove('rotate-180');
      }, 120);
    };
    [trig.parentElement, mega].forEach(function (el) { el.addEventListener('mouseenter', open); el.addEventListener('mouseleave', close); });
    trig.addEventListener('click', function () { mega.hidden ? open() : close(); });
    mega.addEventListener('click', function (e) { if (e.target.closest('a')) mega.hidden = true; });
  }
  var ms = $('[data-lv-msearch]');
  $$('[data-lv-msearch-toggle]').forEach(function (b) {
    b.addEventListener('click', function () { if (!ms) return; ms.hidden = !ms.hidden; if (!ms.hidden) { var i = ms.querySelector('input[name=q]'); i && i.focus(); } });
  });

  /* ---------- sheets (radix look: data-state open/closed drives the css animations) ---------- */
  function sheet(name) { return $('[data-lv-sheet="' + name + '"]'); }
  function openSheet(name) {
    var s = sheet(name); if (!s) return;
    s.hidden = false; document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { $$('[data-state]', s).forEach(function (el) { if (el.parentElement === s) el.setAttribute('data-state', 'open'); }); });
  }
  function closeSheet(name) {
    var s = sheet(name); if (!s || s.hidden) return;
    $$('[data-state]', s).forEach(function (el) { if (el.parentElement === s) el.setAttribute('data-state', 'closed'); });
    setTimeout(function () { s.hidden = true; document.body.style.overflow = ''; }, 280);
  }
  $$('[data-lv-sheet]').forEach(function (s) {
    s.addEventListener('click', function (e) { if (e.target.closest('[data-lv-close]')) closeSheet(s.getAttribute('data-lv-sheet')); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSheet('cart'); closeSheet('menu'); } });
  $$('[data-lv-menu-open]').forEach(function (b) { b.addEventListener('click', function () { openSheet('menu'); }); });
  $$('[data-lv-cart-open]').forEach(function (b) { b.addEventListener('click', function () { renderCart().then(function () { openSheet('cart'); }); }); });

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(title, desc) {
    var t = $('[data-lv-toast]'); if (!t) return;
    t.querySelector('[data-title]').textContent = title;
    t.querySelector('[data-description]').textContent = desc || '';
    t.hidden = false; requestAnimationFrame(function () { t.classList.add('is-in'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.hidden = true; }, 350); }, 3200);
  }

  /* ---------- cart ---------- */
  function setCount(n) {
    $$('[data-lv-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = n === 0; });
  }
  function renderCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var box = $('[data-lv-cart-items]'), foot = $('[data-lv-cart-foot]'), sub = $('[data-lv-cart-sub]');
      setCount(cart.item_count);
      if (sub) sub.textContent = cart.item_count === 0 ? 'Your cart is currently empty.' : cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '');
      if (!box) return cart;
      box.innerHTML = '';
      var wrap = box.parentElement;
      var empty = wrap.querySelector('[data-lv-empty]'); if (empty) empty.remove();
      if (cart.item_count === 0) {
        box.hidden = true; if (foot) foot.hidden = true;
        var e = document.getElementById('lv-cart-empty').content.firstElementChild.cloneNode(true);
        e.setAttribute('data-lv-empty', ''); wrap.appendChild(e);
        return cart;
      }
      box.hidden = false; if (foot) foot.hidden = false;
      var tpl = document.getElementById('lv-cart-item');
      cart.items.forEach(function (it, i) {
        var n = tpl.content.firstElementChild.cloneNode(true), f = function (k) { return n.querySelector('[data-f="' + k + '"]'); };
        if (it.image) { f('img').src = it.image.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2'); f('img').alt = it.product_title; } else f('img').remove();
        f('title').textContent = it.product_title; f('title').href = it.url;
        if (it.variant_title && it.variant_title !== 'Default Title') f('variant').textContent = it.variant_title; else f('variant').remove();
        f('price').textContent = money(it.final_price);
        f('qty').textContent = it.quantity;
        var line = i + 1;
        f('dec').addEventListener('click', function () { changeLine(line, it.quantity - 1); });
        f('inc').addEventListener('click', function () { changeLine(line, it.quantity + 1); });
        f('remove').addEventListener('click', function () { changeLine(line, 0); });
        box.appendChild(n);
      });
      var tot = $('[data-lv-cart-total]'); if (tot) tot.textContent = money(cart.total_price);
      return cart;
    });
  }
  function changeLine(line, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(renderCart);
  }
  function addToCart(id, qty, title) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function () { toast('Added to cart', title); return renderCart(); })
      .then(function () { openSheet('cart'); })
      .catch(function (err) { toast('Could not add to cart', err.message); });
  }
  window.LVaddToCart = addToCart;
  $$('[data-lv-checkout]').forEach(function (b) { b.addEventListener('click', function () { window.location.href = '/checkout'; }); });

  /* ---------- product cards: variant chips switch the price (like Lovable) ---------- */
  var CHIP_ON = ['border-charcoal', 'bg-charcoal', 'text-primary-foreground'], CHIP_OFF = ['border-border', 'text-charcoal', 'hover:border-charcoal'];
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-lv-chip]'); if (!chip) return;
    e.preventDefault(); e.stopPropagation();
    var card = chip.closest('[data-lv-card]');
    $$('[data-lv-chip]', card).forEach(function (c) {
      var on = c === chip;
      CHIP_ON.forEach(function (k) { c.classList.toggle(k, on); }); CHIP_OFF.forEach(function (k) { c.classList.toggle(k, !on); });
    });
    var p = card.querySelector('[data-lv-card-price]'); if (p) p.textContent = chip.getAttribute('data-price');
  }, true);

  /* ---------- accordions (radix markup) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lv-acc]'); if (!btn) return;
    var item = btn.closest('[data-lv-acc-item]'), panel = item.querySelector('[role=region]');
    var opening = btn.getAttribute('data-state') !== 'open';
    if (btn.hasAttribute('data-lv-acc-single')) {
      $$('[data-lv-acc-item]', item.parentElement).forEach(function (o) { if (o !== item) setAcc(o, false); });
    }
    setAcc(item, opening);
    function setAcc(it, on) {
      var b = it.querySelector('[data-lv-acc]'), pn = it.querySelector('[role=region]');
      [it, b, b.parentElement, pn].forEach(function (el) { el.setAttribute('data-state', on ? 'open' : 'closed'); });
      b.setAttribute('aria-expanded', on);
      var plus = b.querySelector('[data-lv-plus]'); if (plus) plus.textContent = on ? '−' : '+';
      if (on) { pn.hidden = false; pn.style.setProperty('--radix-accordion-content-height', pn.scrollHeight + 'px'); }
      else { pn.style.setProperty('--radix-accordion-content-height', pn.scrollHeight + 'px'); setTimeout(function () { if (pn.getAttribute('data-state') === 'closed') pn.hidden = true; }, 200); }
    }
  });

  /* ---------- product page ---------- */
  var pd = $('[data-lv-product]');
  if (pd) {
    var data = JSON.parse(pd.querySelector('script[type="application/json"]').textContent);
    var imgs = data.images, cur = 0;
    var main = pd.querySelector('[data-lv-main-img]'), thumbs = $$('[data-lv-thumb]', pd), dots = $$('[data-lv-dot]', pd);
    var show = function (i) {
      if (!imgs.length) return;
      cur = (i + imgs.length) % imgs.length; main.src = imgs[cur];
      thumbs.forEach(function (t, k) { t.classList.toggle('border-primary', k === cur); t.classList.toggle('border-transparent', k !== cur); t.classList.toggle('hover:border-border', k !== cur); });
      dots.forEach(function (d, k) { d.classList.toggle('w-4', k === cur); d.classList.toggle('bg-primary', k === cur); d.classList.toggle('w-1.5', k !== cur); d.classList.toggle('bg-charcoal/40', k !== cur); });
    };
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = pd.querySelector('[data-lv-prev]'), next = pd.querySelector('[data-lv-next]');
    prev && prev.addEventListener('click', function () { show(cur - 1); });
    next && next.addEventListener('click', function () { show(cur + 1); });
    var sx = null, stage = main.parentElement;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); sx = null; });
    var zoom = pd.querySelector('[data-lv-zoom]');
    zoom && zoom.addEventListener('click', function () {
      var lb = document.createElement('div'); lb.className = 'lv-lightbox';
      lb.innerHTML = '<img alt=""><button style="top:16px;right:16px" aria-label="Close">✕</button><button style="left:16px;top:50%" aria-label="Previous">‹</button><button style="right:16px;top:50%" aria-label="Next">›</button>';
      var im = lb.querySelector('img'), i = cur, set = function () { im.src = imgs[i]; };
      set(); document.body.appendChild(lb); document.body.style.overflow = 'hidden';
      var b = lb.querySelectorAll('button');
      var shut = function () { lb.remove(); document.body.style.overflow = ''; };
      b[0].onclick = shut; b[1].onclick = function () { i = (i - 1 + imgs.length) % imgs.length; set(); }; b[2].onclick = function () { i = (i + 1) % imgs.length; set(); };
      lb.addEventListener('click', function (e) { if (e.target === lb) shut(); });
    });
    // options
    var selected = data.selected.slice();
    var OPT_ON = ['border-charcoal', 'text-charcoal', 'font-medium'], OPT_OFF = ['border-border', 'text-charcoal/80', 'hover:border-charcoal/50'];
    var variant = function () { return data.variants.find(function (v) { return v.options.every(function (o, k) { return o === selected[k]; }); }); };
    var apply = function () {
      var v = variant();
      $$('[data-lv-opt]', pd).forEach(function (b) {
        var on = selected[+b.getAttribute('data-idx')] === b.getAttribute('data-value');
        OPT_ON.forEach(function (k) { b.classList.toggle(k, on); }); OPT_OFF.forEach(function (k) { b.classList.toggle(k, !on); });
      });
      $$('[data-lv-opt-label]', pd).forEach(function (l) { l.textContent = selected[+l.getAttribute('data-idx')]; });
      var btn = pd.querySelector('[data-lv-add]');
      if (!v) { btn.disabled = true; return; }
      $$('[data-lv-price]', pd).forEach(function (p) { p.textContent = money(v.price); });
      $$('[data-lv-compare]', pd).forEach(function (p) { p.hidden = !(v.compare > v.price); p.textContent = money(v.compare || 0); });
      btn.disabled = !v.available;
      pd.querySelector('[data-lv-add-label]').textContent = v.available ? 'Add to Cart' : 'Sold Out';
      if (v.image !== null && v.image !== undefined) show(v.image);
      if (history.replaceState) history.replaceState(null, '', location.pathname + '?variant=' + v.id);
    };
    $$('[data-lv-opt]', pd).forEach(function (b) { b.addEventListener('click', function () { selected[+b.getAttribute('data-idx')] = b.getAttribute('data-value'); apply(); }); });
    var qty = 1, qEl = pd.querySelector('[data-lv-qty]');
    pd.querySelector('[data-lv-dec]').addEventListener('click', function () { qty = Math.max(1, qty - 1); qEl.textContent = qty; });
    pd.querySelector('[data-lv-inc]').addEventListener('click', function () { qty += 1; qEl.textContent = qty; });
    pd.querySelector('[data-lv-add]').addEventListener('click', function () { var v = variant(); if (v) addToCart(v.id, qty, data.title); });
    apply();
  }

  /* ---------- product grids: priced first, load more, merge pages beyond Shopify's 250 limit ---------- */
  $$('[data-lv-grid]').forEach(function (grid) {
    var step = +grid.getAttribute('data-lv-initial') || 48;
    var pages = +grid.getAttribute('data-lv-pages') || 1;
    var btnWrap = grid.parentElement.querySelector('[data-lv-loadmore]');
    btnWrap = btnWrap && btnWrap.parentElement;
    var shown = step;
    function layout() {
      $$('[data-lv-item]', grid).forEach(function (el, i) { el.hidden = i >= shown; });
      if (btnWrap) btnWrap.hidden = $$('[data-lv-item]', grid).length <= shown;
    }
    function merge(items) {
      items.forEach(function (el) {
        if (el.getAttribute('data-lv-priced') === '1') {
          var firstZero = grid.querySelector('[data-lv-item][data-lv-priced="0"]');
          grid.insertBefore(el, firstZero);
        } else grid.appendChild(el);
      });
      layout();
    }
    if (btnWrap) btnWrap.querySelector('button').addEventListener('click', function () { shown += step; layout(); });
    if (pages > 1) {
      var sid = grid.getAttribute('data-lv-section'), jobs = [];
      for (var pg = 2; pg <= pages; pg++) {
        var u = new URL(location.href); u.searchParams.set('page', pg); u.searchParams.set('section_id', sid);
        jobs.push(fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
          var d = document.createElement('div'); d.innerHTML = html;
          return $$('[data-lv-grid] [data-lv-item]', d);
        }));
      }
      Promise.all(jobs).then(function (lists) { merge([].concat.apply([], lists)); });
    }
    layout();
  });

  /* ---------- "Get free quote" style scroll buttons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lv-scroll]'); if (!b) return;
    var t = document.querySelector(b.getAttribute('data-lv-scroll')); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
})();
